// categories.js
'use strict';
import { fromJS } from 'immutable';
import { ADD_CATEGORIES } from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Categories.
 * @module reducer/categories
 */
const categories = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_CATEGORIES:
      return _ADD_CATEGORIES(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add categories
 * @kind reducer/actionType
 * @name _ADD_CATEGORIES
 * @param {object} {categories} - categories using category as keys
 * @return {Immutable.Map} New state
 */
const _ADD_CATEGORIES =
  ({ categories }) =>
  state => {
    return state.mergeDeep(categories);
  };

export default categories;
